import React from "react"

import { exists } from "shared/lib/exists"
import { isValidURL } from "shared/lib/isValidURL"
import { stopPropagation } from "shared/lib/stopPropagation"

function MarkdownLinkComponent({
  href,
  children
}: React.HTMLProps<HTMLAnchorElement>) {
  if (href?.startsWith("#")) return null
  const currentOrigin = window.location.origin
  const isValid = exists(href) && isValidURL(href)
  const targetOrigin = href && isValid ? new URL(href).origin : null

  return (
    <a
      href={isValid ? href : undefined}
      onClick={stopPropagation}
      onFocus={stopPropagation}
      target={currentOrigin === targetOrigin ? "_self" : "_blank"}
      rel="noreferrer"
    >
      {children}
    </a>
  )
}

export const MarkdownLink = React.memo(
  MarkdownLinkComponent
) as typeof MarkdownLinkComponent
